<template>
  <div class="animated fadeIn">
    <default-heading class="mt-3" text="My Samples">
      <template #right>
        <b-button
          variant="primary"
          class="ml-1"
          :to="`/time-series-report`"
        >
          <i class="fal fa-chart-area" />
        </b-button>
      </template>
    </default-heading>
    <div>
      <div class="mt-4" />

      <SampleServerTable />
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import SampleServerTable from '@/components/lab/samples/SampleServerTable.vue'

export default {
  name: "SampleIndex",
  components: {
    DefaultHeading,
    SampleServerTable
  },
}
</script>
